export class BasicVersions {
    public static itemXMLVersion: string;
}

